export enum SupportRatingState {
  NotRated,
  PositiveRated,
  NegativeRated,
  UnknownRating,
}
